import { NextPage } from "next"
import Head from "next/head"
import { useSearchParams } from "next/navigation"
import { useEffect, useState } from "react"
import { DefaultLayout } from "src/components/Layout"
import TransferApplicationsList from "src/features/transfer-applications/components/TransferApplicationsList"
import TransferApplicationsSearch from "src/features/transfer-applications/components/TransferApplicationsSearch"

const TransferApplicationsPage: NextPage = () => {
  const searchParams = useSearchParams()
  const defaultTransferApplicationId = searchParams.get("transferApplicationId")
  const [transferApplicationId, setTransferApplicationId] = useState<number | undefined>(undefined)
  useEffect(() => {
    setTransferApplicationId(
      defaultTransferApplicationId ? Number(defaultTransferApplicationId) : undefined
    )
  }, [defaultTransferApplicationId])
  return (
    <DefaultLayout>
      <Head>
        <title>立替送金申請一覧 | for CS</title>
      </Head>
      <div className="flex w-full flex-col items-center justify-center gap-8">
        <div className="w-full max-w-7xl">
          <div className="mt-8 flex flex-col gap-4">
            <h1 className="text-3xl font-bold text-black">立替送金申請一覧</h1>

            {/* 検索セクション */}
            <TransferApplicationsSearch
              transferApplicationId={transferApplicationId}
              onTransferApplicationIdChange={setTransferApplicationId}
              onSearch={setTransferApplicationId}
            />
          </div>

          {/* 申請一覧 */}
          <TransferApplicationsList transferApplicationId={transferApplicationId} />
        </div>
      </div>
    </DefaultLayout>
  )
}

export default TransferApplicationsPage
